<template>
  <v-layout column>
    <notifications group="deleteUser" position="top center" />
    <v-toolbar color="secondary">
      <v-toolbar-title class="report-title font-weight-thin white--text">
        {{ settings.Name }}
        <strong>Settings</strong>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="hide"
        color="primary"
        class="adminButton"
        @click="openForm('create')"
        round
      >Add {{ settings.Name }}</v-btn>
      <v-btn
        v-if="!hide && parseInt(user.userLevel) >= 100"
        color="primary"
        class="adminButton"
        @click="inviteUser"
        round
      >Invite a new user</v-btn>
      <v-btn color="primary" class="adminButton" round @click="readDocuments()">Refresh</v-btn>
    </v-toolbar>

    <v-layout rows>
      <v-flex xs12>
        <!-- navigation drawer - hide collumns - Start -->
        <v-navigation-drawer
          v-model="drawer"
          absolute
          temporary
          right
          dark
          class="secondary lighten-3"
        >
          <v-list class="pa-1">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>icons8-cog-wheel</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="font-size:20px !important">Hide fields</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
          <v-list style="margin-left: 10% !important; margin-bottom: 13% !important;">
            <v-list-tile-content>
              <v-checkbox
                v-for="(column, index) in Columns"
                :key="index"
                v-model="column.hidden"
                :label="column.label"
                :false-value="true"
                :true-value="false"
                color="white"
                style="max-height:27px !important; max-width: 150px !important;"
              ></v-checkbox>
            </v-list-tile-content>
          </v-list>
          <v-divider></v-divider>
          <v-layout justify-center>
            <v-btn
              color="white"
              light
              style="margin-top: 5% !important"
              @click.stop="drawer = !drawer"
            >Done</v-btn>
          </v-layout>
        </v-navigation-drawer>
        <!-- navigation drawer - hide collumns - End-->

        <!-- Vue Good Table - Start -->
        <vue-good-table
          ref="my-table"
          :columns="Columns"
          :rows="rows"
          :sort-options="SortOptions"
          :search-options="SearchOptions"
          :pagination-options="Pagination"
          style-class="vgt-table condensed bordered striped"
          row-style-class="tablerowheight"
        >
          <!--drawer button - hide collumns -->
          <div slot="table-actions">
            <v-btn outline fab small color="primary" right @click.stop="drawer = !drawer">
              <v-icon dark>icons8-cog-wheel</v-icon>
            </v-btn>
          </div>
          <template slot="table-column" slot-scope="props">
            <span class="tablerowheight">{{ props.column.label }}</span>
          </template>
          <!-- edit and delete options -->
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <v-icon color="primary" class="tableicon" @click="openForm('edit', props.row)">edit</v-icon>&nbsp;&nbsp;
              <v-icon
                color="primary"
                class="tableicon"
                @click="
                  deleteDocument(props.row.id, props.row.name)
                "
              >delete</v-icon>
            </span>
            <span v-if="props.column.type === 'array'" class="tablefont">
              <v-chip
                v-for="(item, index) in props.formattedRow[
                  props.column.field
                ]"
                :key="index"
              >{{ item }}</v-chip>
            </span>
            <span v-else class="tablefont">{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
        <!-- Vue Good Table - End -->
      </v-flex>
    </v-layout>
    <v-dialog v-model="Dialog" max-height="70%" max-width="55%" >
      <component
        :is="componentName"
        :form="Form"
        :portal="portal"
        :formaction="formAction"
        :settings="settings"
        :portallookups="portalLookups"
        :portallist="portalList"
        @Dialog="Dialog = $event"
      />
    </v-dialog>
    <v-dialog v-model="inviteUserDialog" max-height="70%" max-width="55%">
      <InviteUser :portallist="portalList" :form="Form" @inviteUserDialog="inviteUserDialog = $event" />
    </v-dialog>
  </v-layout>
 
</template>

<script>
import { mapState } from "vuex";
import "@/components/forms";
import InviteUser from "@/components/forms/InviteUser.vue";
import axios from "axios";
import Vue from "vue";

export default {
  components: {
    InviteUser
  },
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    confirmModal: false,
    hideColumns: [],
    portalList: [],
    portalLookups: [],
    formAction: "create",
    Form: {},
    inviteUserDialog: false,
    Dialog: false,
    portalDialog: false,
    rows: [],
    Pagination: {
      enabled: true,
      mode: "records",
      perPage: 12,
      setCurrentPage: 1,
      position: "bottom",
      perPageDropdown: [5, 10, 20, 30, 40, 50],
      dropdownAllowAll: true,
      nextLabel: "Next",
      prevLabel: "Prev",
      rowsPerPageLabel: "Rows per page",
      ofLabel: "of",
      pageLabel: "Page", // for "pages" mode
      allLabel: "All"
    },

    SearchOptions: { enabled: true },
    SortOptions: {
      enabled: false
    },
    drawer: null,
    items: [
      { title: "Home", icon: "dashboard" },
      { title: "About", icon: "question_answer" }
    ]
  }),
  computed: {
    ...mapState({
      Portals: state => state.Settings.Portals,
      portal: state => state.portal,
      Documents: state => state.Settings.Documents,
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL,
      user: state => state.user.active
    }),
    Columns() {
      return this.schema.columns;
    },
    componentName() {
      return this.settings.Component;
    },
    hide() {
      return this.settings.Component !== "user";
    }
  },
  watch: {
    portal: {
      handler: function() {
        this.readDocuments();
        this.readPortals();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
        //console.log("PortalWatch = " + JSON.stringify(this.Portals, null, 2));
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.rows = this.Documents;
        if(this.componentName == "portal")
        {
          this.rows = this.Portals;
        }
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    settings: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      },
      deep: true
    },
    Dialog() {
      this.readDocuments();
    },
    Form: {
      handler: function() {
        //console.log(JSON.stringify(this.Form, null, 2));
      },
      deep: true
    }
  },
  mounted() {
    this.readDocuments();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  methods: {
    onConfirm() {
			this.$emit("confirm");
		},
		onCancel() {
			this.$emit("cancel");
		},
    hideColumn(i) {
      this.schema.columns[i].hidden = true;
    },
    readDocuments() {
      this.$store.dispatch("Settings/readDocuments", [
        this.settings.Collection,
        this.portal.active.id,
        "Settings/setDocuments"
      ]);
    },
    deleteDocument(id) {
      var confirm = window.confirm("Are you sure you want to delete this record?");
      if(confirm === true){
        if (!this.hide) {
        //delete user from the table and from firebase auth
        axios
          .get(
            this.FirebaseFunctionsURL +
              "deleteUserFromAuthentication?userID=" +
              id
          )
          .then(response => {
            // console.log("response result" + response.data.result);
            if (response.data.result === true) {
              Vue.notify({
                group: "deleteUser",
                title: "Success",
                text: "Successfully deleted user",
                type: "success"
              });
            } else {
              // console.log("Error deleting user");
            }
          });
      }
      console.log("delete user");
      this.$store.dispatch("Settings/deleteDocument", [
        this.settings.Collection,
        id,
        "Settings/setDocumentResult"
      ]);
      this.readDocuments();
      this.readPortals();
      }     
    },
    updateDocument() {
      this.$store.dispatch("Settings/updateDocument", [
        this.settings.Collection,
        this.Form.id,
        this.Form
      ]);
      this.readDocuments();
      this.readPortals();
    },
    openForm(action, record) {
      if (this.portal.active.id !== null) {
        switch (action) {
          case "create":
            this.Form = {};
            this.Form.portalID = [];
            this.Form.portalID.push(this.portal.active.id);
            this.Form.enabled = false;
            this.formAction = "create";
            this.Dialog = true;
            break;
          case "edit":
            this.Form = record;
            this.formAction = "edit";
            this.Dialog = true;
            break;
          default:
            this.Form = {};
            this.formAction = "create";
            this.Dialog = true;
            break;
        }
      } else {
        alert("Please Select a Portal before continuing.");
      }
    },
    readPortals() {
      this.$store.dispatch("Settings/readPortals");
      this.portalDialog = true;
    },
    readLookups() {
      this.$store.dispatch("Settings/readLookups", [this.portal.active.id]);
    },
    inviteUser() {
      this.inviteUserDialog = true;
    }
  }
};
</script>

<style>
h1 {
  font-size: 30px !important;
}
.tablerowheight {
  height: 25px !important;
  font-size: 13px !important;
}
.tableicon {
  font-size: 20px !important;
}
.hidden {
  display: none;
}
.vgt-global-search__actions {
  margin-left: 50px !important;
}
.vgt-global-search__input {
  padding-top: 10px !important;
}
.v-list__tile__title {
  height: 25px !important;
}
.v-input--selection-controls.v-input .v-label {
  top: 4px !important;
}
</style>
